module.exports = __webpack_public_path__ + "img/pro-modal-features.b82e97e.png";